define('models/AnalyticsConversation',[
    'lib/knockout',
    'lib/lodash4',
    'moment',
    'util/ObservableModel'
], function (
    ko,
    _,
    moment,
    ObservableModel
) {
    'use strict';

    var Segment = ObservableModel.extend({
        defaults: {
            segmentStart: null,
            segmentEnd: null,
            segmentType: '',
            queueId: '',
            // non-api property
            participant: null,
            session: null
        }
    }, function () {
        var self = this;

        self.segmentStart(self.segmentStart() ? moment(self.segmentStart()) : null);
        self.segmentEnd(self.segmentEnd() ? moment(self.segmentEnd()) : null);
    });

    var Session = ObservableModel.extend({
        defaults: {
            callbackNumbers: [],
            callbackScheduledTime: '',
            callbackUserName: '',
            mediaType: '',
            scriptId: '',
            outboundCampaignId: '',
            outboundContactId: '',
            outboundContactListId: '',
            sessionId: '',
            skipEnabled: true,
            timeoutSeconds: 0,
            // non-api property
            participant: null
        },
        modelProperties: {
            segments: Segment
        }
    }, function () {
        var self = this;

        self.callbackScheduledTime(self.callbackScheduledTime() && self.callbackScheduledTime() != '0' ?
            moment(self.callbackScheduledTime()) :
            null);
    });

    var Participant = ObservableModel.extend({
        defaults: {
            participantId: '',
            purpose: ''
        },
        modelProperties: {
            sessions: Session
        }
    });

    return ObservableModel.extend({
        defaults: {
            organizationId: '',
            conversationId: '',
            conversationStart: null,
            conversationEnd: null,
            divisionIds: []
        },
        modelProperties: {
            participants: Participant
        }
    }, function () {
        var self = this;

        _.forEach(self.participants(), function (participant) {
            _.forEach(participant.sessions(), function (session) {
                session.participant(participant);
                _.forEach(session.segments(), function (segment) {
                    segment.participant(participant);
                    segment.session(session);
                });
            });
        });
    });
});
